import React from 'react'
type Props = {
  width?: string
  height?: string
  color?: string
}

function Pending({ width = '24', height = '24', color = '#F4821F' }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='12'
        cy='12'
        r='12'
        fill='#F4821F'
      />
      <path
        d='M10.5 15.25H13.5M9.3 7H14.7C14.98 7 15.12 7 15.227 7.0545C15.3211 7.10243 15.3976 7.17892 15.4455 7.273C15.5 7.37996 15.5 7.51997 15.5 7.8V8.83726C15.5 9.08185 15.5 9.20414 15.4724 9.31923C15.4479 9.42127 15.4075 9.51881 15.3526 9.60828C15.2908 9.7092 15.2043 9.79568 15.0314 9.96863L13.5657 11.4343C13.3677 11.6323 13.2687 11.7313 13.2316 11.8455C13.1989 11.9459 13.1989 12.0541 13.2316 12.1545C13.2687 12.2687 13.3677 12.3677 13.5657 12.5657L15.0314 14.0314C15.2043 14.2043 15.2908 14.2908 15.3526 14.3917C15.4075 14.4812 15.4479 14.5787 15.4724 14.6808C15.5 14.7959 15.5 14.9182 15.5 15.1627V16.2C15.5 16.48 15.5 16.62 15.4455 16.727C15.3976 16.8211 15.3211 16.8976 15.227 16.9455C15.12 17 14.98 17 14.7 17H9.3C9.01997 17 8.87996 17 8.773 16.9455C8.67892 16.8976 8.60243 16.8211 8.5545 16.727C8.5 16.62 8.5 16.48 8.5 16.2V15.1627C8.5 14.9182 8.5 14.7959 8.52763 14.6808C8.55213 14.5787 8.59253 14.4812 8.64736 14.3917C8.7092 14.2908 8.79568 14.2043 8.96863 14.0314L10.4343 12.5657C10.6323 12.3677 10.7313 12.2687 10.7684 12.1545C10.8011 12.0541 10.8011 11.9459 10.7684 11.8455C10.7313 11.7313 10.6323 11.6323 10.4343 11.4343L8.96863 9.96863C8.79568 9.79568 8.7092 9.7092 8.64736 9.60828C8.59253 9.51881 8.55213 9.42127 8.52763 9.31923C8.5 9.20414 8.5 9.08185 8.5 8.83726V7.8C8.5 7.51997 8.5 7.37996 8.5545 7.273C8.60243 7.17892 8.67892 7.10243 8.773 7.0545C8.87996 7 9.01997 7 9.3 7Z'
        stroke='white'
        strokeWidth='1.2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default Pending
